/*
 * File: StoryModal.jsx
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on February 4, 2022 at 4:30 PM
 * Copyright © 2023 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: May 30, 2025 at 1:20 AM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

// Components
import { Modal } from '../Modal';

// Styles
import * as S from './StoryModal.styles';
import { StoryComponent } from '../StoryComponent';


/**
 * Component
 */

export const StoryModal = ({
	className,
	isOpen,
	handleClose,
	story
}) => {

	// Handle actions on component load
	useEffect(() => {}, []);

	// Render component
	return (
		<Modal className={className} isOpen={isOpen} handleClose={handleClose} clickOutsideClose useWrapper variant="large">
			<S.ModalInner>

				{/* Story */}
				<StoryComponent story={story} />

			</S.ModalInner>
		</Modal>
	);
};


/**
 * Configuration
 */

StoryModal.displayName = 'StoryModal';
StoryModal.propTypes = {
	className: PropTypes.string,
	isOpen: PropTypes.bool,
	handleClose: PropTypes.func,
	story: PropTypes.shape()
};
StoryModal.defaultProps = {
	className: null,
	isOpen: false,
	handleClose: null,
	story: null
};
